export class Roles {
  static SuperAdmin = "SuperAdmin";
  static PortalUser = "PortalUser";
  static MobileAppUser = "MobileAppUser";
  static AccountingUser = "AccountingUser";
  static WorkshopUser = "WorkshopUser";
  static DealerUser = "DealerUser";
  static CalculatorUser = "CalculatorUser";
  static PartsSupplierUser = "PartsSupplierUser"; 
}
